import { Trans } from "react-i18next";
import { Envelope, GitHub, LinkedIn } from "../Icons";

import styles from "./Credits.module.css";

export default function Credits() {
  const year = new Date(Date()).getFullYear();

  return (
    <div className={styles.credits}>
      <div className={styles["creative-commons"]}>
        <Trans
          i18nKey="Credits.madeBy"
          components={{ strong: <strong />, em: <em /> }}
          values={{ year }}
        />{" "}
        <a
          href="https://creativecommons.org/licenses/by-nc-sa/4.0/"
          target="_blank"
          rel="noreferrer"
        >
          CC BY-NC-SA 4.0
        </a>{" "}
        <img
          src="https://mirrors.creativecommons.org/presskit/icons/cc.svg"
          alt="creative commons cc"
          className={styles["cc-icon"]}
        />
        <img
          src="https://mirrors.creativecommons.org/presskit/icons/by.svg"
          alt="creative commons by"
          className={styles["cc-icon"]}
        />
        <img
          src="https://mirrors.creativecommons.org/presskit/icons/nc.svg"
          alt="creative commons nc"
          className={styles["cc-icon"]}
        />
        <img
          src="https://mirrors.creativecommons.org/presskit/icons/sa.svg"
          alt="creative commons sa"
          className={styles["cc-icon"]}
        />
      </div>
      <div className={styles.social}>
        <div className="linkedin">
          <a
            href="https://ca.linkedin.com/in/alberto-trujillo-gonz%C3%A1lez-b7955aa8"
            target="_blank"
            rel="noreferrer"
          >
            <span className="sr-only">LinkedIn</span>
            <LinkedIn />
          </a>
        </div>
        <div className="github">
          <a
            href="https://github.com/altrugon"
            target="_blank"
            rel="noreferrer"
          >
            <span className="sr-only">GitHub</span>
            <GitHub />
          </a>
        </div>
        <div className="email">
          <a href="mailto:altrugon@gmail.com">
            <span className="sr-only">Email</span>
            <Envelope />
          </a>
        </div>
      </div>
    </div>
  );
}
